import { LANGUAGE } from '@/types/commonConst';

import type { MessageMap } from '..';

export const topicMessages = {
  AI_SUGGESTION_TOOLTIP: {
    [LANGUAGE.EN]:
      'AI will suggest topics based on all remaining feedback not able to link with existing topics.',
  },
  NO_UNLINKED_FEEDBACK: {
    [LANGUAGE.EN]: 'There are no unlinked feedback',
  },
  CREATE_TOPIC_TOOLTIP: {
    [LANGUAGE.EN]:
      'A topic is a cluster of customer feedback with shared themes. Try automatic/manual classification to link feedback to relevant topics.',
  },
} as const satisfies MessageMap;
